import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 28, className = '', as = 'div' }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-70px' }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </Tag>
  );
};

export const MaskedLine = ({ children, delay = 0, className = '' }) => (
  <span className={`block overflow-hidden pb-[0.12em] ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: '110%' }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);
